// record-sdk.js
import Recorder from './recorder';
/* eslint-disable */
export default class Record {
  startRecord(param) {
    const self = this;
    try {
      Recorder.get((rec) => {
        if (rec.error) return param.error(rec.error);
        self.recorder = rec;
        self.recorder.start();
        param.success('开始录音');
      });
    } catch (e) {
      param.error(`开始录音失败${e}`);
    }
  }

  stopRecord(param) {
    const self = this;
    try {
      const blobData = self.recorder.getBlob();
      param.success(blobData);
    } catch (e) {
      param.error(`结束录音失败${e}`);
    }
  }

  play(audio) {
    const self = this;
    try {
      self.recorder.play(audio);
    } catch (e) {
      console.warn(`录音播放失败${e}`);
    }
  }

  getBlob() {
    const self = this;
    try {
      return self.recorder.getBlob();
    } catch (e) {
      console.warn(`录音播放失败${e}`);
    }
  }

  clear(audio) {
    const self = this;
    try {
      self.recorder.clear(audio);
    } catch (e) {
      console.warn(`清空录音失败${e}`);
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/record-sdk.js